import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHomeData } from '../../../models'

export const getEnrollmentHomeDataMock: EnrollmentHomeData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/intro',
}

export const mockGetEnrollmentHomeData = graphql.mutation('getEnrollmentMultiHomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHomeDataMock } })
})

export const mockEnrollmentHome = [mockGetEnrollmentHomeData]
